import React from 'react';

import { DateTimeUtils, Notification, STATUS_TYPES } from 'dyl-components';
import accountActions from 'actions/account';
import sequenceTasksActions from 'actions/sequence_tasks';
import customerPipelineActions from 'actions/customer_pipeline';
import { useDispatch, useSelector } from 'react-redux';
import ProfileStages from 'shared/ProfileStages';
import { StringUtils } from 'utils';

const StagesSectionContainer = ({
    id,
    assignees
}) => {
    const isDyl = useSelector(state => state.auth.dyl_employee);

    const { customer_information } = useSelector(state => ({
        account: state.account.account,
        isUpdating: state.account.isUpdatingAccount,
        customer_information: state.account.account?.customer || {}
    }))

    const { customer_status, customer_status_activity, customer_pipeline, fund_type } = customer_information;
    
    const dispatch = useDispatch();

    const onTransitionPipeline = async (stage_name) => {
        const newStage = (customer_pipeline?.stages.map(({ id, name, sequence_id }) => {
            return {
                key: id,
                content: name,
                sequence_id
            };
        }) || [])?.find(stage => stage.content === stage_name);
        const stage_id = newStage.key;
        if (Number(customer_pipeline.pipeline_stage_id) === Number(stage_id)) {
            return;
        }
    
        const associatedContact = customer_pipeline?.associated_contact?.id;
        try {
            await dispatch(customerPipelineActions.update(id, {
                pipeline_stage_id: Number(stage_id),
                person_id: associatedContact,
                pipeline_id: customer_pipeline?.pipeline_id,
                sequence_id: newStage?.sequence_id || null
            }, { action: 'transition' }));
            Notification.alert(`Successfully updated stage!`, STATUS_TYPES.SUCCESS);
            dispatch(accountActions.readAccount(id));
            dispatch(sequenceTasksActions.readContactTasks(associatedContact));
        } catch (e) {
            console.log(e);
            Notification.alert('Failed to update stage', STATUS_TYPES.ERROR);
        }
    };

    const isTransitioningPipeline = useSelector(state => state.customer_pipeline.accountBeingUpdated || state.contact_sequence.isRemovingSequence || state.sequences.isAddingContactToSequence);

    return (
        <ProfileStages
            assignees={assignees}
            otherInfo={customer_status === 'canceled' ? <span><b>Customer Canceled</b>: {DateTimeUtils.formatEpoch(customer_status_activity, "MM/DD/YYYY")}</span> : null}
            onTransitionPipeline={onTransitionPipeline}
            current_stage={{
                account_stage: 'customer',
                ...((customer_pipeline?.stages || []).length > 0 ? customer_pipeline : {})
            }}
            isTransitioningPipeline={isTransitioningPipeline}
            fund_type={isDyl ? `${fund_type !== 'funded' ? StringUtils.capitalize(fund_type) : ''}` : ''}
        />
    );
}

const StagesSection = ({
    id,
    assignees
}) => {
    const isDyl = useSelector(state => state.auth.dyl_employee);

    const { customer_information, isReadingSequenceContactTasks } = useSelector(state => ({
        account: state.account.account,
        isUpdating: state.account.isUpdatingAccount,
        customer_information: state.account.account?.customer || {},
        isReadingSequenceContactTasks: state.sequence_tasks.isReadingSequenceContactTasks
    }))

    const { customer_status, customer_status_activity, customer_pipeline, fund_type } = customer_information;

    if (isReadingSequenceContactTasks) {
        return (
            <ProfileStages
                assignees={assignees}
                otherInfo={customer_status === 'canceled' ? <span><b>Customer Canceled</b>: {DateTimeUtils.formatEpoch(customer_status_activity, "MM/DD/YYYY")}</span> : null}
                onTransitionPipeline={() => {}}
                current_stage={{
                    account_stage: 'customer',
                    ...((customer_pipeline?.stages || []).length > 0 ? customer_pipeline : {})
                }}
                isTransitioningPipeline={isReadingSequenceContactTasks}
                fund_type={isDyl ? `${fund_type !== 'funded' ? StringUtils.capitalize(fund_type) : ''}` : ''}
            />
        )
    }

    return (
        <StagesSectionContainer id={id} assignees={assignees} />
    );
};

export default StagesSection;
